import { List as GqlList, ListType } from 'modules/domains/list';

export type List = Omit<GqlList, 'projectId' | 'publicId'>;

export type NewCSV = {
  totalRows: number;
  validRows: number;
  invalidRows: number;
  invalidEmailData: Array<unknown>;
  invalidTypeData: Array<unknown>;
  traceUserBatchInfo: Array<unknown>;
};

export type NewList = {
  createdAt: number;
  creatorUserId: string;
  emailListType: ListType;
  id: number;
  name: string;
  updatedAt: number;
  projectId: number;
  teamId: number;
  publicId: string;
  isPublic: boolean;
  isDeleted: boolean;
};

export type NewListResponse = {
  emailList: NewList;
  csvImportResult: NewCSV;
};

export type CreateListConfig = {
  projectId: number;
  name: string;
  description?: string;
  emailListType: ListType;
  sendContactAddEvent: boolean;
  updateExistingUsersOnly: boolean;
  csvFile?: string;
};

export type RenameListConfig = {
  emailListId: number;
  name: string;
};

export enum LIST_COLUMNS {
  name = 'Name',
  type = 'ListType',
  users = 'Users',
  lastModifiedBy = 'LastModifiedBy',
  overflowMenu = 'OverflowMenu',
}

export enum LIST_QUERY_PARAMS {
  type = 'type',
  list = 'list',
  search = 'search',
  folderId = 'folderId',
}

export enum ListIndexModalState {
  createFolder = 'createFolder',
  moveFolderContents = 'moveFolderContents',
  confirmDelete = 'confirmDelete',
  createListInFolder = 'createListInFolder',
  renameListFolder = 'renameListFolder',
  deleteListFolderAndContents = 'deleteListFolderAndContents',
}
